// extracted by mini-css-extract-plugin
export var locationCard = "_gd-0";